import _ from 'lodash'
import student from './shared/student'
import { ActionTypes } from '../constants'
import group from './teachers/group'
import Group from '@app/models/group'
import statistic from './teachers/statistic'
import diplomas from './shared/diplomas'

const teachers = (state = {
  classes: {
    objects: {},
    fetching: false,
    didInvalidate: false,
    updatedOn: null,
    error: null,
    group: group(undefined, {}),
    lastModifiedGroup: null
  }
}, action) => {
  switch (action.type) {
  case ActionTypes.CLASSES_REQUEST:
    return {
      ...state,
      classes: Object.assign({}, state.classes, {
        fetching: true,
        error: null,
        didInvalidate: false
      })
    }

  case ActionTypes.CLASSES_RECEIVING_SUCCESS:
    return {
      ...state,
      classes: Object.assign({}, state.classes, {
        fetching: false,
        updatedOn: action.updatedOn,
        objects: _.mapValues(_.keyBy(action.classes, 'id'), (value) => {
          return group(undefined, {
            type: ActionTypes._CLASS_ACTION_SUCCESS,
            object: value,
            updatedOn: action.updatedOn
          })
        })
      })
    }

  case ActionTypes.CLASSES_RECEIVING_FAILURE:
    return {
      ...state,
      classes: Object.assign({}, state.classes, {
        fetching: false,
        error: action.error,
        didInvalidate: true
      })
    }

  case ActionTypes.ADD_LEARNER_REQUEST:
    var target = state.classes.objects[action.classId]
    return {
      ...state,
      classes: {
        ...state.classes,
        objects: Object.assign({}, state.classes.objects, {
          [action.classId]: {
            ...target,
            student: student(target.student || undefined, {
              type: ActionTypes._STUDENT_ACTION_REQUEST,
              object: action.object
            })
          }
        })
      }
    }

  case ActionTypes.ADD_LEARNER_SUCCESS:
    var target = state.classes.objects[action.classId]
    return {
      ...state,
      classes: {
        ...state.classes,
        objects: Object.assign({}, state.classes.objects, {
          [action.classId]: {
            ...target,
            student: student(undefined, {}),
            students: Object.assign({}, target.students, {
              [action.object.id]: student(undefined, {
                type: ActionTypes._STUDENT_ACTION_SUCCESS,
                object: action.object
              })
            })
          }
        })
      }
    }

  case ActionTypes.ADD_LEARNER_FAILURE:
    var target = state.classes.objects[action.classId]
    return {
      ...state,
      classes: {
        ...state.classes,
        objects: Object.assign({}, state.classes.objects, {
          [action.classId]: {
            ...target,
            student: student(target.student || undefined, {
              type: ActionTypes._STUDENT_ACTION_FAILURE,
              error: action.error
            })
          }
        })
      }
    }

  case ActionTypes.UPDATE_LEARNER_REQUEST:
  case ActionTypes.DESTROY_LEARNER_REQUEST:
    return {
      ...state,
      classes: {
        ...state.classes,
        objects: Object.assign({}, state.classes.objects, {
          [action.classId]: group(state.classes.objects[action.classId], {
            type: ActionTypes._STUDENT_ACTION_REQUEST,
            object: action.object
          })
        })
      }
    }

  case ActionTypes.UPDATE_LEARNER_SUCCESS:
    return {
      ...state,
      classes: {
        ...state.classes,
        objects: Object.assign({}, state.classes.objects, {
          [action.classId]: group(state.classes.objects[action.classId], {
            type: ActionTypes._STUDENT_ACTION_SUCCESS,
            object: action.object
          })
        })
      }
    }

  case ActionTypes.DESTROY_LEARNER_FAILURE:
  case ActionTypes.UPDATE_LEARNER_FAILURE:
    return {
      ...state,
      classes: {
        ...state.classes,
        objects: Object.assign({}, state.classes.objects, {
          [action.classId]: group(state.classes.objects[action.classId], {
            type: ActionTypes._STUDENT_ACTION_FAILURE,
            object: action.object,
            error: action.error
          })
        })
      }
    }

  case ActionTypes.DESTROY_LEARNER_SUCCESS:
    var target = state.classes.objects[action.classId]
    return {
      ...state,
      classes: {
        ...state.classes,
        objects: Object.assign({}, state.classes.objects, {
          [action.classId]: {
            ...target,
            students: _.omit(target.students, action.object.id)
          }
        })
      }
    }

  case ActionTypes.CLASS_STATISTICS_REQUEST:
  case ActionTypes.CLASS_STATISTICS_RECEIVING_SUCCESS:
  case ActionTypes.CLASSES_RECEIVING_FAILURE:
    var classId = action.group.object.id
    var target = state.classes.objects[classId]
    return {
      ...state,
      classes: {
        ...state.classes,
        objects: Object.assign({}, state.classes.objects, {
          [classId]: {
            ...target,
            statistics: Object.assign({}, target.statistics, {
              [action.tour]: statistic(target.statistics[action.tour], action)
            })
          }
        })
      }
    }

  case ActionTypes.CREATE_CLASS_REQUEST:
    return {
      ...state,
      classes: {
        ...state.classes,
        group: group(state.group, { ...action, type: ActionTypes._CLASS_ACTION_REQUEST }),
        lastModifiedGroup: null
      }
    }

  case ActionTypes.CREATE_CLASS_FAILURE:
    return {
      ...state,
      classes: {
        ...state.classes,
        group: group(state.group, { ...action, type: ActionTypes._CLASS_ACTION_FAILURE })
      }
    }

  case ActionTypes.CREATE_CLASS_SUCCESS:
    return {
      ...state,
      classes: Object.assign({}, state.classes, {
        objects: Object.assign({}, state.classes.objects, {
          [action.object.id]: group(undefined, { ...action, type: ActionTypes._CLASS_ACTION_SUCCESS })
        }),

        group: group(undefined, {}),
        lastModifiedGroup: new Group(action.object)
      })
    }

  case ActionTypes.CLASS_DIPLOMAS_REQUEST:
  case ActionTypes.CLASS_DIPLOMAS_RECEIVING_SUCCESS:
  case ActionTypes.CLASS_DIPLOMAS_RECEIVING_FAILURE:
    var classId = action.group.object.id
    var target = state.classes.objects[classId]
    return {
      ...state,
      classes: {
        ...state.classes,
        objects: Object.assign({}, state.classes.objects, {
          [classId]: {
            ...target,
            diplomas: Object.assign({}, target.diplomas, {
              [action.event]: diplomas(target.diplomas[action.event], action)
            })
          }
        })
      }
    }

  default:
    return state
  }
}

export default teachers
